import Radio from "backbone.radio";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { formatInTimeZone } from "date-fns-tz";
import { captureException } from "extensions/sentry";
import { _ } from "extensions/underscore";
import $ from "jquery";
import { capitalize, curry, endsWith, isPlainObject, mapKeys, startsWith, throttle } from "lodash-es";
import moment from "moment";

export const escapeForCSV = function(text = "") {
    let escapedText;
    if (typeof text === "boolean" || Number.isFinite(text)) { // Handle numerical values and booleans
        escapedText = text.toString();
    } else if (text === null) {
        escapedText = "";
    } else {
        escapedText = text.replace(/"/g, "\"\"\""); // Escape double quotes;
    }
    
    // If text has a comma, but not wrapped into quotes then we should escape it by wrapping in quotes
    if (escapedText.includes(",")
        && !startsWith(escapedText, "\"")
        && !endsWith(escapedText, "\"")) {
        escapedText = `"${escapedText}"`;
    }
    
    return escapedText;
};

export const validateEmail = function(email) {
    /* eslint-disable */
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* eslint-enable */
    return re.test(email);
};

/**
 * Returns nested property values or passed as a function
 * @param {Backbone.Model} model Backbone model to get the property from
 * @param {String|Function} modelProperty Either string or function that describe model property
 */
export const getWalkableModelValue = function(model, modelProperty) {
    if (typeof modelProperty === "undefined") {
        return void 0;
    }
    if (typeof modelProperty === "function") {
        return modelProperty(model);
    }
    
    const walkable = modelProperty.split(".");
    let value = model.get(walkable.shift());
    
    // If passed something like "property.foo.bar"
    while (walkable.length) {
        value = value[walkable.shift()];
    }
    return value;
};

// http://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
export const getScrollbarWidth = (function() {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // Needed for WinJS apps
    
    document.body.appendChild(outer);
    
    const widthNoScroll = outer.offsetWidth;
    
    // Force scrollbars
    outer.style.overflow = "scroll";
    
    // Add innerdiv
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    
    const widthWithScroll = inner.offsetWidth;
    
    // Remove divs
    outer.parentNode.removeChild(outer);
    
    return widthNoScroll - widthWithScroll;
}());

// http://timnew.me/blog/2014/06/23/process-nexttick-implementation-in-browser/
/* eslint-disable */
export const nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
        && window.setImmediate;
    var canPost = typeof window !== 'undefined'
            && window.postMessage && window.addEventListener
        ;
    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }
    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            if (ev.source === window && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);
        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '/');
        };
    }
    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();
/* eslint-enable */

export const isJqueryEvent = function(a) {
    return a instanceof $.Event;
};

export const updateStickyItemsWidth = function(context) {
    $(".sticky", context).each((index, el) => {
        if (($(el).hasClass("noInitStick") && !hasScrollBar(document.body).vertical)) {
            return;
        }
        const elParent = $(el).parent();
        const parentWidth = elParent.width();
        // In order to accommodate controls next to the tabs need to account for width of controls box.
        const siblingWidth = $(el).siblings(".sticky-sibling").width() || 0;
        $(el).css("width", parentWidth - siblingWidth);
    });
};

export const getTabIDFromChildView = function(childView, parentClassName = ".analytics-view-wrapper") {
    if (!childView) {
        throw new Error("childView is required to drilldown");
    }
    
    const tabView = childView.$el.closest(parentClassName).parent();
    if (tabView.length) {
        return tabView.attr("id");
    }
};

export const intervalToMomentDurationAliases = {
    day: "days",
    week: "weeks",
    month: "months",
    year: "years"
};

export const intervalToIsoFormat = {
    day: "YYYY-MM-DD",
    week: "YYYY-[W]WW",
    month: "YYYY-MM",
    year: "YYYY",
    quarter: "YYYY-[Q]Q"
};

export const formatDate = function(start, end, options) {
    const start_moment = moment.isMoment(start) ? start : moment.utc(start);
    const end_moment = moment.isMoment(end) ? end : moment.utc(end);
    const opts = _.defaults({}, options, {
        suffix: null,
        prefix: null
    });
    
    const monthStart = start_moment.format("MMM");
    const dayStart = start_moment.format("D");
    const yearStart = start_moment.format("YYYY");
    
    const monthEnd = end_moment.format("MMM");
    const dayEnd = end_moment.format("D");
    const yearEnd = end_moment.format("YYYY");
    
    let formatted;
    
    if (yearStart === yearEnd) {
        if (monthStart === monthEnd) {
            formatted = `${monthStart} ${dayStart}-${dayEnd}`; // Nov 22-28
        } else {
            formatted = `${monthStart} ${dayStart} - ${monthEnd} ${dayEnd}`; // Nov 28 - Dec 04
        }
    } else {
        formatted = `${monthStart} ${dayStart}, ${yearStart} - ${monthEnd} ${dayEnd}, ${yearEnd}`; // Nov 28, 2015 - Dec 04, 2016
    }
    
    if (opts.prefix !== null) {
        formatted = `${opts.prefix}${formatted}`;
    }
    
    if (opts.suffix !== null) {
        formatted = `${formatted}${opts.suffix}`;
    }
    
    return formatted;
};

export const weekToText = function(timestamp, includeWeekNumber, skipNormalization = false, dates = false) {
    const start_moment = moment.isMoment(timestamp) ? timestamp : moment.utc(timestamp);
    
    if (!dates) {
        // Get global datepicker
        const picker = Radio.channel("main").request("global:datepicker:get");
        dates = {
            start: picker.startDate,
            end: picker.endDate
        };
    }
    
    let normalizedStart;
    let normalizedEnd;
    
    if (skipNormalization) {
        normalizedStart = start_moment.clone().startOf("isoweek");
        normalizedEnd = start_moment.clone().endOf("isoweek");
    } else {
        normalizedStart = moment.max(start_moment.clone().startOf("isoweek"), dates.start);
        normalizedEnd = moment.min(start_moment.clone().endOf("isoweek"), dates.end);
    }
    
    const monthStart = normalizedStart.format("MMM");
    const dayStart = normalizedStart.format("D");
    const yearStart = normalizedStart.format("YYYY");
    const monthEnd = normalizedEnd.format("MMM");
    const dayEnd = normalizedEnd.format("D");
    const yearEnd = normalizedEnd.format("YYYY");
    const weekNumber = normalizedStart.format("W");
    
    const isPartialWeek = skipNormalization ? false : start_moment.clone().startOf("isoweek") < dates.start || dates.end < start_moment.clone().endOf("isoweek");
    let tmpl;
    
    if (monthStart === monthEnd) {
        tmpl = "$mStart $dStart - $dEnd"; // Nov 22 - 28
    } else if (yearStart === yearEnd) {
        tmpl = "$mStart $dStart - $mEnd $dEnd"; // Nov 28 - Dec 04
    } else {
        tmpl = "$mStart $dStart, $yStart  - $mEnd $dEnd, $yEnd"; // Nov 28, 2015 - Dec 04, 2016
    }
    
    if (includeWeekNumber) {
        tmpl = `Week $weekNumber$partial<br/>${tmpl}`; // Week 6<line_break> ...
    }
    
    return _.interpolate(tmpl, {
        mStart: monthStart,
        mEnd: monthEnd,
        dStart: dayStart,
        dEnd: dayEnd,
        yStart: yearStart,
        yEnd: yearEnd,
        weekNumber,
        partial: isPartialWeek ? " (partial)" : ""
    });
};

function djb2(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i); /* hash * 33 + c */
    }
    return hash;
}

export const hashStringToColor = function(str) {
    const hash = djb2(str);
    const r = Math.min((hash & 0xFF_00_00) >> 16, 230);
    const g = Math.min((hash & 0x00_FF_00) >> 8, 230);
    const b = Math.min(hash & 0x00_00_FF, 230);
    
    return `#${`0${r.toString(16)}`.substr(-2)}${`0${g.toString(16)}`.substr(-2)}${`0${b.toString(16)}`.substr(-2)}`;
};

/**
 * Make a help popover
 * @param {String} str Popover body
 */
export const helpTip = function(str) {
    return `<i class="far fa-question-circle pz-popover" role="button" data-html="true" data-toggle="popover" data-trigger="hover" data-placement="top" data-content="${str}"></i>`;
};

/**
 * Clean up tooltips and popovers
 */
export const destroyPopovers = throttle(() => {
    ["tooltip", "popover"].forEach((elt) => {
        try {
            $(`.${elt}:not(.no-dismiss)`)[elt]("destroy");
        } catch {
            // noop
        }
    });
}, 500);

export const hasScrollBar = function(elt) {
    const e = $(elt).get(0);
    const { scrollHeight, clientHeight, scrollWidth, clientWidth } = e;
    
    return {
        vertical: scrollHeight > clientHeight,
        horizontal: scrollWidth > clientWidth
    };
};

export const nestPivotInCollection = function(collection, pivots = [], nest = "date_time") {
    // Try to get raw json if collection has toJSON method
    const data = _.result(collection, "toJSON", collection);
    
    if (pivots.length === 0) {
        throw new Error("Pivots list should have at least one pivot to nest");
    }
    
    // Then reduce to an object for faster lookup
    const reduced = data.reduce((memo, elt) => {
        // Compute hash based on pivot values
        const pivotValues = pivots.reduce((all, p) => {
            all[p] = elt[p];
            return all;
        }, {});
        const hash = JSON.stringify(pivotValues);
        memo[hash] = memo[hash] || { [nest]: [], ...pivotValues };
        memo[hash][nest].push(elt);
        
        return memo;
    }, {});
    
    const values = Object.values(reduced);
    
    if (nest === "date_time") {
        const sortByDate = (a, b) => {
            const dateA = moment.utc(a.date_time);
            const dateB = moment.utc(b.date_time);
    
            if (dateA.isAfter(dateB)) {
                return 1;
            } if (dateA.isBefore(dateB)) {
                return -1;
            }
            
            return 0;
        };
        
        // Sort date_time by date
        return values.map((v) => ({ ...v, date_time: v.date_time.sort(sortByDate) }));
    }
    
    return values;
};

// from http://stackoverflow.com/a/33928558/567135
export const copyToClipboard = function(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
    } if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        const textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (error) {
            window.console.warn("Copy to clipboard failed.", error);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
};

// http://stackoverflow.com/a/38710376
export const onVisibilityChange = function(callback) {
    let visible = true;
    
    function focused() {
        if (!visible) {
            callback(visible = true);
        }
    }
    
    function unfocused() {
        if (visible) {
            callback(visible = false);
        }
    }
    
    // Standards:
    if ("hidden" in document) {
        document.addEventListener("visibilitychange", () => {
            (document.hidden ? unfocused : focused)();
        });
    }
    if ("mozHidden" in document) {
        document.addEventListener("mozvisibilitychange", () => {
            (document.mozHidden ? unfocused : focused)();
        });
    }
    if ("webkitHidden" in document) {
        document.addEventListener("webkitvisibilitychange", () => {
            (document.webkitHidden ? unfocused : focused)();
        });
    }
    if ("msHidden" in document) {
        document.addEventListener("msvisibilitychange", () => {
            (document.msHidden ? unfocused : focused)();
        });
    }
    // IE 9 and lower:
    if ("onfocusin" in document) {
        document.addEventListener("focusin", focused);
        document.addEventListener("focusout", unfocused);
    }
    // All others:
    window.addEventListener("pageshow", focused);
    window.addEventListener("focus", focused);
    
    window.addEventListener("pagehide", unfocused);
    window.addEventListener("blur", unfocused);
};

export const getDecimalSeparator = function() {
    const n = 1.1;
    const which = n.toLocaleString().substring(1, 2); // example for testing.. n.toLocaleString("de-DE").substring(1, 2);
    return {
        holder: which,
        charCode: which === "." ? 46 : 44,
        cleanWhat: which === "." ? "," : "."
    };
};

export const removeURLParameter = function({ url, parameter }) {
    const urlparts = url.split("?");
    if (urlparts.length >= 2) {
        const prefix = `${encodeURIComponent(parameter)}=`;
        const pars = urlparts[1].split(/[&;]/g);

        // reverse iteration as may be destructive
        for (let i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? `?${pars.join("&")}` : "");
        return url;
    }
    return url;
};

const loadedExternalScripts = {};
export const loadExternalScript = function(src) {
    // Create a promise for the newScript
    return new Promise((resolve, reject) => {
        // Check if we have loaded this script in the past
        if (loadedExternalScripts[src]) {
            resolve();
            return;
        }
        
        // Create an html script element
        const script = document.createElement("script");
        
        // Set the source of the script element
        script.src = src;
        
        // Set a listener when the script element finishes loading the script
        script.addEventListener("load", () => {
            // Resolve if the script element loads
            loadedExternalScripts[src] = 1;
            resolve();
        });
        // Set a listener when the script element faces any errors while loading
        script.addEventListener("error", (e) => {
            // Reject if the script element has an error while loading the script
            let error;
            if (e instanceof Error) {
                error = e;
            } else {
                error = new Error("Failed loading external script");
            }
            reject(error);
        });
        // Append the script element to the body
        document.body.appendChild(script);
    });
};

export const stackToErrorMessage = function({ stack }) {
    const [line1 = "", line2 = ""] = stack.split("\n");
    return `${line1.trim()}<div>${line2.trim().replace("webpack:///./webapplication/static/js/", "").replace("webpack-internal:///./webapplication/static/js/", "")}</div>`;
};

// #https://stackoverflow.com/questions/16308037/detect-when-elements-within-a-scrollable-div-are-out-of-view
export const checkInView = function(container, element, partial = false) {
    // Get container properties
    const cTop = container.scrollTop;
    const cBottom = cTop + container.clientHeight;
    
    // Get element properties
    const eTop = element.offsetTop;
    const eBottom = eTop + element.clientHeight;
    
    // Check if in view
    const isTotal = eTop >= cTop && eBottom <= cBottom;
    const isPartial = partial && (
        (eTop < cTop && eBottom > cTop)
        || (eBottom > cBottom && eTop < cBottom)
    );
    
    // Return outcome
    return isTotal || isPartial;
};

// #https://stackoverflow.com/questions/16308037/detect-when-elements-within-a-scrollable-div-are-out-of-view
export const ensureInView = function(container, element) {
    // Determine container top and bottom
    const cTop = container.scrollTop;
    const cBottom = cTop + container.clientHeight;
    
    // Determine element top and bottom
    const eTop = element.offsetTop;
    const eBottom = eTop + element.clientHeight;
    
    // Check if out of view
    if (eTop < cTop) {
        container.scrollTop -= cTop - eTop;
    } else if (eBottom > cBottom) {
        container.scrollTop += eBottom - cBottom;
    }
};

export const isInViewport = function(el) {
    const bounding = el.getBoundingClientRect();
    return (
        bounding.top >= 0
        && bounding.left >= 0
        && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

export const makeElFromString = function({ tagName = "div", content = "" } = {}) {
    const el = document.createElement(tagName);
    el.innerHTML = content.trim();
    return el;
};

export const sumProperties = function(initial, current) {
    if (Number.isFinite(current)) {
        initial = (initial || 0) + current;
    } else if (_.isObject(current)) {
        initial = initial || {};
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const i in current) {
            initial[i] = sumProperties(initial[i], current[i]);
        }
    }
    return initial;
};

export const normalizeDateValueToUtcZ = function(date) {
    if (date) {
        date = moment.isMoment(date) ? date : moment.utc(date);
        return moment(`${date.format("YYYY-MM-DDTHH:mm:ss.SSS")}Z`).utc();
    }
    return null;
};

/**
 * Converts an ISO date string to the specified format in UTC.
 * @param {string} date The ISO date to be converted (e.g. "2022-11-11T23:59:59.999Z").
 * @param {string} format The desired target format (e.g. "yyyyMMdd").
 * @returns {string} The formatted date aligned with UTC.
 */
export const isoDateToUtc = (date, format) => formatInTimeZone(date, "UTC", format);

export const toQueryString = function(parameters = {}, encode = true) {
    const normalizer = encode ? encodeURIComponent : (v) => v;
    
    return Object.entries(parameters).reduce((components, [key, value]) => {
        if (value !== null && value !== "" && typeof value !== "undefined" && (Array.isArray(value) ? value.length : true)) {
            const normalizedValue = Array.isArray(value) ? value.map(normalizer).join(",") : normalizer(value);
            return [...components, `${key}=${normalizedValue}`];
        }
        return components;
    }, []).join("&");
};

export const fromQueryString = function(queryString) {
    if (!queryString) {
        return {};
    }
    
    return queryString.replace("?", "").split("&").reduce((memo, parameter) => {
        if (parameter.length > 0) {
            const [key, value] = parameter.split("=").map(decodeURIComponent);
            return {
                ...memo,
                [key]: value
            };
        }
        return memo;
    }, {});
};

export const jsonToTable = function(columns = [], data = []) {
    const table = document.createElement("table");
    
    // Add Header
    const headerRow = table.insertRow(-1);
    headerRow.innerHTML = columns.map(({ header }) => `<td>${header}</td>`).join("");
    
    // Add Data
    data.forEach((obj) => {
        const dataRow = table.insertRow(-1);
        dataRow.innerHTML = columns.map(({ attribute }) => {
            let value = obj[attribute];
            if (value === null) {
                value = "";
            }
            return `<td>${value}</td>`;
        }).join("");
    });
    
    return table.outerHTML;
};

export const domId = function(prefix) {
    return (
        prefix
        + Math.random()
            .toString(36)
            .substr(2, 10)
    );
};

export const updateQueryStringParameters = function(url, param, value) {
    const re = new RegExp(`[\\?&]${param}=([^&#]*)`);
    const match = re.exec(url);
    let delimiter;
    let newString;
    
    if (match === null) {
        // Append new parameter since it's new
        const hasQuestionMark = /\?/.test(url);
        delimiter = hasQuestionMark ? "&" : "?";
        newString = `${url}${delimiter}${param}=${value}`;
    } else {
        delimiter = match[0].charAt(0);
        newString = url.replace(re, `${delimiter}${param}=${value}`);
    }
    
    return newString;
};

export const merchantNameNormalizer = (str) => str
    .replace(/[aàáâãä]/gi, "a")
    .replace(/[eèéêëẽ]/gi, "e")
    .replace(/[iìíîïĩ]/gi, "i")
    .replace(/[oòóôõö]/gi, "o")
    .replace(/[uùúûüũ]/gi, "u")
    .replace(/[çćč]/gi, "c");

export const arrayToCSV = function(array) {
    // Find all unique keys in the array
    const keys = Object.keys(array.reduce((memo, cur) => ({
        ...memo,
        ...cur
    }), {}));
    
    const rows = array.map((cur) => keys.map((key) => escapeForCSV(cur[key])).join(","));
    
    return `${keys.join(",")}\r\n${rows.join("\r\n")}`;
};

export const downloadCSV = function(filename, csv) {
    const fn = filename.replace(/ /gi, "-") || "export.csv";
    
    // Data URI
    const csvDataURI = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
    
    if ("download" in document.createElement("a")) {
        // Chrome, FF
        const link = $("<a></a>").attr({
            id: "downloadFile",
            download: fn,
            href: csvDataURI
        });
        
        link.appendTo("body");
        
        link.get(0).click();
        
        link.detach();
    } else if ("msSaveOrOpenBlob" in navigator) {
        const blob = new Blob([decodeURIComponent(encodeURI(csv))], {
            type: "text/csv;charset=utf-8;"
        });
        navigator.msSaveBlob(blob, fn);
    } else {
        // Safari
        window.open(csvDataURI);
    }
};

export const removeMongoObjFromFilename = function(str, separator = "_") {
    return str.split(separator).filter((part) => !/^(?=[\da-f]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(part)).join(separator);
};

export const getQFilter = ({ keys = [], obj = {}, encode = true } = {}) => {
    const q = new Qualifiers();
    keys.forEach((key) => {
        if (obj?.[key]) q.add(`${key}:${Qualifiers.normalizeValue(obj[key])}`);
    });
    return q.toString(encode);
};

// Find all values of `keyToFind` in nested object/array
export const findAllByKey = (input, keyToFind) => (Array.isArray(input) ? input.map((v) => [void 0, v]) : Object.entries(input)).reduce((memo, [key, value]) => {
    if (key === keyToFind) return [...memo, value];
    if (isPlainObject(value) || Array.isArray(value)) return [...memo, ...findAllByKey(value, keyToFind)];
    return memo;
}, []);

export const scrollUp = () => {
    try {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    } catch {
        window.scrollTo(0, 0);
    }
};

export const renameKeys = curry((keyMappings, obj) => mapKeys(obj, (v, k) => keyMappings[k] || k));

/**
 * Converts qualifiers string into readable list of tokens
 * @param {String} qualifiersString string of qualifiers i.e. "providers%3Awpg%20-status%3Apending"
 * @param {String} delimiter sequence of one or more characters for specifying the boundary between separate tokens
 * @returns {String} string of tokens i.e "+wpg_-pending"
 */
export const stringifyFilterTokens = (qualifiersString, delimiter = " ") => {
    // Check if string is valid
    if (!Qualifiers.isValid(qualifiersString)) {
        captureException(new Error(`Qualifiers string is not valid: ${qualifiersString}`));
        return "";
    }

    return new Qualifiers({ value: qualifiersString })
        .toTokens()
        .map(({ ref, operator }) => (operator === "=" ? `+${ref}` : `-${ref}`))
        .join(delimiter);
};

/**
 * Converts qualifiers string into a string with values digestable for webix pazienSelectFilter sepatated by "|""
 * @param {Object} param0
 * @param {Array} param0.categories A list of categories to parse
 * @param {Boolean} param0.customOptions for edge case in reconciliation, look Flagged/Reconciled
 * @param {String} param0.value A string of qualifiers
 * @returns {String} a string with values digestable for pazienSelectFilter sepatated by "|""
 */
export const parseQualifiersForFilters = ({ categories, customOptions = false, value = "" }) => {
    const qualifiers = new Qualifiers({ value });
    
    if (customOptions) {
        return categories.reduce((memo, c) => {
            if (qualifiers.has(c)) {
                return [...memo, capitalize(c)];
            }
            return memo;
        }, []).join("|");
    }
    
    return categories.map((c) => qualifiers.get(c, true)
        .filter((item) => item.operator === "=")
        .map((item) => item.value)
        .join("|")).join(" ");
};

export * as accounting from "common/helpers/accountingHelper";
